var isRTL = ($('html').attr('dir') == "rtl") ? true : false,
    headerHeight,
    winWidth = $(window).width(),
    winHeight = $(window).height(),
    vform,
    form_status = 0,
    resized = false,
    initPopup = false;

var parser = new UAParser();
var result = parser.getResult();
var browserName = result.browser.name;
var browserVersion = parseInt(result.browser.version);

$(function () {
    initWOW();
    // langPopup();
    setVideoBannerHTML();
    initDataDesktopMob();
    readyfunction();
    browserDetect();
    initVideoBanner();
    if (winWidth <= 1024) {
        // scrollSecInit();
    }
    jsScrollDown();
    initTabs();
    initInteractiveView();
    initDraggable();
    initCarousel();
    validation('.js-form-validation');
    bindPopupEve();
    initCookie();
    pageScrollVideo();
    fieldsfilter();
    initSideNav();
    paralax1();
    initDatepicker('.js-flatpickrinline','true',2);
});

$(window).on('load', function () {
    // Do after Page ready
    doOnLoad();
    calApplyHeights()
    headerFixed();
    loadDelayedSvgs();
    initDatepicker('.js-flatpickrinline','true',2);
});

$(window).on('resize orientationchange', function () {
    if(winWidth != $(window).width()) {
        resized = true;
        // Do on resize
        winWidth = $(window).width(),
            winHeight = $(window).height();
        calApplyHeights();
        initDatepicker('.js-flatpickrinline','true',2);
        setTimeout(function(){
            resized = false;
        });
    }
});

$(window).on('scroll', function () {
    //Do on Scroll
    headerFixed();
    paralax1();
});

$(document).keyup(function (e) {
    if (e.keyCode == 27) {
        //Do on ESC press
        closePopup();
    }
});

function doOnLoad() {
    //OnLoad Function
    checkFieldval($('.js-input-check'));
}

function readyfunction() {
    $(document).on("focus", ".js-input-check", function (e) {
        $(this).parents('.form-group').addClass('is--focus');
    }).on("blur", ".js-input-check", function (e) {
        $(this).parents('.form-group').removeClass('is--focus');
    });
    $('.js-last-field').keyup(function() {
        var $ths = $(this);
        checkvalidation('.js-form-validation',$ths);
        // vform.resetForm();
    });
}

function onSubmit(token) {
    var popformsubmit = $('.js-form-validation');
    popformsubmit.submit();
}

function checkFieldval(element) {
    $(element).each(function (i, index) {
        inputValue = $(index).val().length;
        if (inputValue > 0) {
            $(index).parents('.form-group').addClass('is--used');
            $(index).parents('.form-group').addClass('interacted--once');
        } else {
            $(index).parents('.form-group').removeClass('is--used');
        }
    });
    $(element).keyup(function (i, index) {
        var getTar = $(i.currentTarget);
        inputValue = $(getTar).val().length;
        if (inputValue > 0) {
            $(getTar).parents('.form-group').addClass('is--used');
            $(getTar).parents('.form-group').addClass('interacted--once');
        } else {
            $(getTar).parents('.form-group').removeClass('is--used');
        }
    });
}

function browserDetect() {
    navigator.sayswho = (function () {
        var ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join('').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    })();
    $('body').addClass(navigator.sayswho);
}

/* ============================== */
/* START - Banner Video */

function setVideoBannerHTML(){
    if($('.js-video-nav-container-1').get(0)){
        if(browserName == 'Edge' || browserName == 'IE') {
            $('.js-video-nav-container-1 .video-container, .js-video-nav-container-1  .view-container').remove();
        }else{
            $('.js-video-nav-container-1 .c-img-video-container').remove();
        }
    }
}

function initVideoBanner() {
    if($('.js-video-nav-container-1').get(0)){
        if(browserName == 'Edge' || browserName == 'IE') {
            initVideoBannerAsImg();
        }else{
            initVideoBannerProper();
        }
    }
}
function initVideoBannerAsImg(){
    $('.js-video-nav-container-1').each(function(){
        var self = this,
            parentContainer = $(this);

        $(this).addClass('first-played-ended');
        $(this).addClass('activate');
        parentContainer.find('.view-points-wrap .view-points').eq(0).addClass('is--active');
        $('.js-video-nav-1', this).click(function(e){
            e.preventDefault();

            var thisIndex = $(this).index();
            
            // Switch poitns
            parentContainer.find('.view-points-wrap .view-points').addClass('is--active');
            parentContainer.find('.view-points-wrap .view-points').hide();
            parentContainer.find('.view-points-wrap .view-points').eq(thisIndex).show();

            // Img Switch
            parentContainer.find('.c-img-video-container .img-item').removeClass('is--active');
            parentContainer.find('.c-img-video-container .img-item').eq(thisIndex).addClass('is--active');

            // Active Class
            if($(this).index() == 0) {
                parentContainer.addClass('on-first-link');
            }else{
                parentContainer.removeClass('on-first-link');
            }
            parentContainer.find('.js-video-nav-1').removeClass('is--active');
            $(this).addClass('is--active');
        });
        setTimeout(function(){
            $('.js-video-nav-1', self).eq(0).trigger('click');
        }, 500);
    });
}
function initVideoBannerProper(){
    var iV_played = false,
        map_played = false;
    $('.js-video-nav-container-1').each(function(){
        var thisVideo = $(this).find('video')[0],
            parentContainer = $(this),
            prevTime = 0,
            videoTime = 0,
            targetTime = 0,
            directionForward = true,
            expectedTime = 0,
            expectedUpdate = false,
            thisInterval,
            prevVideoTime = 0,
            first_played_till_end = false;
        window.onscroll = function () {
            thisVideo.pause();
        };

        $('.js-video-nav-1', this).click(function(e){
            e.preventDefault();
            targetTime = +$(this).attr('data-video-target');
            expectedUpdate = true;
            if(thisVideo.currentTime < targetTime) {
                directionForward = true;
            }else{
                directionForward = false;
            }
            if(!thisInterval) {
                initThisInterval();
            }

            // Active Class
            if($(this).index() == 0) {
                parentContainer.addClass('on-first-link');
            }else{
                parentContainer.removeClass('on-first-link');
            }
            parentContainer.find('.js-video-nav-1').removeClass('is--active');
            $(this).addClass('is--active');
        });

        // Set Video Updater
        function initThisInterval() {
            if(parentContainer.find('.view-points').get(0)){
                parentContainer.find('.view-points').removeClass('is--active');
            }
            thisInterval = setInterval(function () {
                if(thisVideo.currentTime.toFixed(2) == expectedTime.toFixed(2) || expectedUpdate) {
                    var vidCurrentTime = thisVideo.currentTime.toFixed(2);
                    if(vidCurrentTime == videoTime) {
                        if(directionForward) {
                            if(videoTime < targetTime+0.2) {
                                videoTime = videoTime + 0.04;
                            }
                        }else{
                            if(videoTime > targetTime+0.2) {
                                videoTime = videoTime - 0.04;
                            }
                        }
                        videoTime = parseFloat(videoTime.toFixed(2));

                        setTimeout(function(){
                            if(prevTime != videoTime) {
                                thisVideo.currentTime = videoTime;
                                prevTime = videoTime;
                                expectedTime = videoTime;
                                expectedUpdate = false;
                            }else{
                                clearInterval(thisInterval);
                                thisInterval = null;
                                if(!first_played_till_end){
                                    parentContainer.addClass('first-played-ended');
                                    first_played_till_end = true;
                                }
                                if(parentContainer.hasClass('js-interactive-view')) {
                                    parentContainer.addClass('activate');
                                    var targetIndex = parentContainer.find('.js-video-nav-1.is--active').index();
                                    parentContainer.find('.view-points').eq(targetIndex).addClass('is--active');
                                }
                            }
                        }, 20);
                    }else{
                        thisVideo.currentTime = videoTime;
                    }
                }
            }, 40);
        }
    });
    setTimeout(function(){
        updateOnScrollVideo();
    }, 1000);
    $(window).on('scroll', function () {
        updateOnScrollVideo();
    });
    function updateOnScrollVideo() {
        if (iV_played == false) {
            if (isInViewport($('.js-interactive-view')[0])) {
                $('.js-interactive-view .js-video-nav-1').eq(0).trigger('click');
                iV_played = true;
            }
        }
        if (map_played == false) {
            if (isInViewport($('.c-map-video.js-video-nav-container-1')[0])) {
                var targetLink = $('.c-map-video.js-video-nav-container-1 .js-video-nav-1').eq($('.c-map-video.js-video-nav-container-1 .js-video-nav-1').length-1);
                targetLink.trigger('click');
                map_played = true;
            }
        }
    }

}

/* END - Banner Video */
/* ============================== */


/* ============================== */
/* START - Banner Paralax */

var paraScrollstart = null,
    paraBannerAnimationSpeed = 1000,
    paraBanner = $('[data-scroll-sec]'),
    paraBannerSlideIndex = 0,
    paraBannerTotalSlides = $('[data-scroll-sec]').attr('data-scroll-sec'),
    paraBannerActive = true,
    paraBannerAnimating = false;

function scrollSecInit() {
    if ($('[data-scroll-sec]').get(0)) {
        /*$([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, 0);
        $(window).on('load', function () {
            setTimeout(function(){
                $([document.documentElement, document.body]).animate({
                    scrollTop: 0
                }, 0);
            },10);
        });*/
        $('html').addClass('banner-paralax--scroll');

        window.addEventListener('scroll', function () {
            if ($(window).scrollTop() == 0) {
                paraBannerStart();
                paraBannerUp();
            }
        });

        $("html, body").on({
            ontouchmove: function (e) {
                e.preventDefault();
            }
        });

        $(".c-video-banner")
            .swipeDetector()
            .on("swipeUp.sd swipeDown.sd", function (event) {
                if (event.type === "swipeUp") {
                    paraBannerChange('down');
                } else if (event.type === "swipeDown") {
                    paraBannerChange('up');
                }
            });

        // For Mousewheel

        window.addEventListener('mousewheel', function (e) {
            if ($(window).scrollTop() == 0) {
                if (e.wheelDelta < 0) {
                    paraBannerChange('down');
                } else {
                    paraBannerChange('up');
                }
            }
        });

        // To Set first one
        $('[data-scroll-sec] .video-nav a').eq(0).addClass('is--active');
    }
}
var tl;

var isStartingAutoPlay = false;
function pageScrollVideo() {
    if ($('.js-page-scroll video').get(0)) {
        var playStarted = false;
        var videoDuration = 41;
        var videoSpeed = 1000; // decrease value to increase speed & vice versa
        var scrollVideo = $('.js-page-scroll video')[0];
        var videoTime = 0;
        var isStartingAuto = false;
        var autoPlayEnded = false;
        var timelineTimes = [0, 3.5, 6, 8.5, 11, 15, 18, 21.7, 27.7, 33.7, 39];
        var timelineAudoPlayTill = timelineTimes[6];
        var videoLength = 0;
        var mobVideoTime;
        var mobInterValVariable;
        var videoEnded = false;
        var scrollPos = $(window).scrollTop();

        function mobSetInterval() {
            mobInterValVariable = setInterval(function () {
                if(scrollPos > 1) {
                    clearInterval(mobInterValVariable);
                    return;
                }
                mobVideoTime = scrollVideo.currentTime;
                tl.seek(mobVideoTime);
                if(mobVideoTime > timelineAudoPlayTill){
                    $('body').addClass('autoplay-video-ended');
                }else{
                    $('body').removeClass('autoplay-video-ended');
                }
                if(mobVideoTime > (timelineAudoPlayTill+1)){
                    $('body').addClass('video-area-white');
                }else{
                    $('body').removeClass('video-area-white');
                }
                if(!videoLength) {
                    videoLength = scrollVideo.duration;
                }
                if(mobVideoTime >= videoLength-0.1){
                    $('.js-scroll-to-video').trigger('click');
                    videoEnded = true;
                }
            }, 40);
        }
        function mobRemoveInterval() {
            clearInterval(mobInterValVariable);
        }
        if(winWidth < 768) {
            if(scrollPos <= 1) {
                scrollVideo.play();
                mobSetInterval();
            }

            window.onscroll = function () {
                scrollPos = $(window).scrollTop();
                if(scrollPos > 1) {
                    mobRemoveInterval();
                    scrollVideo.pause();
                }else{
                    if(videoEnded) {
                        scrollVideo.currentTime = 0;
                    }
                    scrollVideo.play();
                    $('body').removeClass("header-fixed");
                    mobSetInterval();
                }
            };
        }else{
            if($('.js-page-scroll.js-page-scroll-a').get(0)){
                isStartingAuto = true;

                if(initPopup) {
                    isStartingAutoPlay = false;
                }else{
                    isStartingAutoPlay = true;
                }
            }
            
            var scrolLArea = videoDuration * videoSpeed + winHeight;
            if(isStartingAuto){
                scrolLArea = (videoDuration * videoSpeed + winHeight) - (timelineTimes[6] * videoSpeed);
            }
            $('.js-page-scroll .scroll-area').css('height', scrolLArea);
            window.onscroll = function () {
                scrollVideo.pause();
            };
            var prevTime = 0;
            setInterval(function () {
                if(isStartingAuto){
                    var scrollPos = $(window).scrollTop();
                    if(scrollPos > 1) {
                        autoPlayEnded = true;
                        scrollVideo.pause();
                        $('body').addClass('autoplay-video-ended');
                    }

                    if(!autoPlayEnded) {
                        videoTime = scrollVideo.currentTime;
                        if(videoTime > timelineAudoPlayTill) {
                            autoPlayEnded = false;
                            scrollVideo.pause();
                            setTimeout(function(){
                                $('body').addClass('autoplay-video-ended');
                            });
                        }
                    }else{
                        videoTime = (window.pageYOffset / videoSpeed) + timelineAudoPlayTill;
                        if(videoTime > (timelineAudoPlayTill+.6)) {
                            $('body').addClass('video-area-white');
                        }else{
                            $('body').removeClass('video-area-white');
                        }
                    }
                }else{
                    videoTime = window.pageYOffset / videoSpeed;
                }

                if(prevTime != videoTime) {
                    if(!isStartingAuto || (isStartingAuto && autoPlayEnded)){
                        scrollVideo.currentTime = videoTime;
                    }
                    tl.seek(videoTime);
                    setNavActive(videoTime);
                    prevTime = videoTime;
                }
                if(videoTime > 0 && !playStarted) {
                    $('.js-page-scroll').addClass('play-started');
                    playStarted = true;
                }
            }, 40);
        }

        tl = gsap.timeline();
        tl.to(".js-page-scroll .txt:nth-child(1)", {
            opacity: 1,
            duration: 0
        });
        tl.to(".js-page-scroll .txt:nth-child(1)", {
            opacity: 0,
            duration: .5,
            delay: 1.5
        });
        // 1.5
        tl.to(".js-page-scroll .txt:nth-child(2)", {
            opacity: 1,
            duration: .5,
            delay: 1.5
        });
        tl.to(".js-page-scroll .txt:nth-child(2)", {
            opacity: 0,
            duration: .5,
            delay: 1
        });
        // 4.5
        tl.to(".js-page-scroll .txt:nth-child(3)", {
            opacity: 1,
            duration: .5,
            delay: 1
        });
        tl.to(".js-page-scroll .txt:nth-child(3)", {
            opacity: 0,
            duration: .5,
            delay: .5
        });
        // 7.5
        tl.to(".js-page-scroll .txt:nth-child(4)", {
            opacity: 1,
            duration: .5,
            delay: .5
        });
        tl.to(".js-page-scroll .txt:nth-child(4)", {
            opacity: 0,
            duration: .5,
            delay: 1
        });
        // 10
        tl.to(".js-page-scroll .txt:nth-child(5)", {
            opacity: 1,
            duration: .5,
            delay: .5
        });
        tl.to(".js-page-scroll .txt:nth-child(5)", {
            opacity: 0,
            duration: .5,
            delay: 1
        });
        // 12.5
        tl.to(".js-page-scroll .txt:nth-child(6)", {
            opacity: 1,
            duration: .5,
            delay: 1
        });
        tl.to(".js-page-scroll .txt:nth-child(6)", {
            opacity: 0,
            duration: .5,
            delay: .5
        });
        // 15
        tl.to(".js-page-scroll .txt:nth-child(7)", {
            opacity: 1,
            duration: 2,
            delay: 1.5
        });
        tl.fromTo(".js-page-scroll .txt:nth-child(7)", {
            scale: .05
        }, {
            scale: 1,
            duration: 2,
            delay: -2.5,
            ease: "power1.in"
        });
        tl.to(".js-page-scroll .txt:nth-child(7)", {
            opacity: 0,
            duration: .5,
            delay: -.5
        });
        // 17.5
        tl.to(".js-page-scroll .txt:nth-child(8)", {
            opacity: 1,
            y: 0,
            duration: .5,
            delay: 2
        });
        tl.to(".js-page-scroll .txt:nth-child(8)", {
            opacity: 0,
            y: -winHeight/2,
            duration: .5,
            delay: 1.2
        });
        // 21.7
        tl.to(".js-page-scroll .txt:nth-child(9)", {
            opacity: 1,
            y: 0,
            duration: .5,
            delay: 1
        });
        tl.to(".js-page-scroll .txt:nth-child(9)", {
            opacity: 0,
            y: -winHeight/2,
            duration: .5,
            delay: 4
        });
        // 27.7
        tl.to(".js-page-scroll .txt:nth-child(10)", {
            opacity: 1,
            y: 0,
            duration: .5,
            delay: 1
        });
        tl.to(".js-page-scroll .txt:nth-child(10)", {
            opacity: 0,
            y: -winHeight/2,
            duration: .5,
            delay: 4
        });
        // 33.7
        tl.to(".js-page-scroll .txt:nth-child(11)", {
            opacity: 1,
            y: 0,
            duration: .5,
            delay: 1
        });
        tl.to(".js-page-scroll .txt:nth-child(11)", {
            opacity: 0,
            y: -winHeight/2,
            duration: .5,
            delay: 4
        });
        tl.pause();

        $('.js-scroll-video-nav').click(function(e){
            e.preventDefault();
            var targetIndex = $(this).index();
            if(targetIndex <= 5) {
                $('.js-scroll-video-nav').removeClass('is--active');
                $(this).addClass('is--active-1');
                $('html, body').animate({
                    scrollTop: 0
                }, 0);
                if(winWidth >= 768){
                    autoPlayEnded = false;
                    $('.autoplay-video-ended').removeClass('autoplay-video-ended');
                    $('.video-area-white').removeClass('video-area-white');
                    
                    $('.c-video-banner-scroll video')[0].currentTime = 0;
                    setTimeout(function(){
                        $('.c-video-banner-scroll video')[0].play();
                    }, 100);
                }
                var targetTime = timelineTimes[0];
                return;
            }

            var targetTime = timelineTimes[targetIndex];
            var scrollTo = (targetTime+1) * videoSpeed;
            if(isStartingAuto){
                scrollTo = scrollTo - (timelineAudoPlayTill * videoSpeed);
                if(targetIndex == 6) {
                    scrollTo = 0;
                }
            }

            $('html, body').animate({
                scrollTop: scrollTo
            }, 1000);
        });

        // Autoplay
        if(winWidth >= 768){
            if(isStartingAuto){
                if(!initPopup){
                    pageScrollVideoPlayNow();
                }
            }
        }

        $('.js-scroll-to-video').click(function (e) {
            e.preventDefault();
            if(winWidth >= 768){
                autoPlayEnded = true;
                if($('.autoplay-video-ended').get(0)) {
                    $('html, body').animate({
                        scrollTop: ($('.c-video-banner-wrap').height() - $('.c-header .header-cover').outerHeight())  + 10
                    }, 500);
                }else{
                    $('html, body').animate({
                        scrollTop: 2
                    }, 100);
                }
            }else{
                $('html, body').animate({
                    scrollTop: winHeight - headerHeight + 11
                }, 500);
            }
        });

        function setNavActive(videoTime) {
            videoTime = videoTime +1;
            for(var i = 0; i <= timelineTimes.length-1; i++) {
                if((videoTime > timelineTimes[i]  && videoTime < timelineTimes[i+1]) || videoTime > timelineTimes[timelineTimes.length-1]) {
                    $('.js-scroll-video-nav').removeClass('is--active');
                    $('.js-scroll-video-nav').eq(i).addClass('is--active');
                }
            }
        }

    }

    // $(window).on('load', function () {
    //     setTimeout(function(){
    //         initScrollStop();
    //     }, 500);
    // });
    // function initScrollStop() {
    //     var container = $('.c-map-video');
    //     if(winWidth >= 768 && container.get(0)) {
    //         var thisInterval,
    //             stopBot = true;
    //         var eTop = container.offset().top;
    //         // $(document).scrollTop(eTop);
    //         var eHeight = container.height();
    //         var eBottom = ($('.c-video-banner-wrap').height() - $('.c-header .header-cover').outerHeight())  + 9;
    //         if($(window).scrollTop() < eBottom) {
    //             $(document).on("scroll", function(e){
    //                 var windowScrollTop = $(window).scrollTop();
    //                 if(windowScrollTop > eBottom){
    //                     if(stopBot){
    //                         // e.preventDefault();
    //                         $(document).scrollTop(eBottom);
    //                         if(!thisInterval) {
    //                             thisInterval = setTimeout(function(){
    //                                 stopBot = false;
    //                             }, 100);
    //                         }
    //                     }
    //                 }
    //             });
    //         }
    //     }
    // }
}

function pageScrollVideoPlayNow(){
    $('.c-video-banner-scroll video')[0].play();
    $('.js-page-scroll .js-scroll-video-nav:nth-child(n+6)').css('display', 'block');
}

function paraBannerChange(state) {
    if (paraBannerActive) {
        if (!paraBannerAnimating) {
            paraBannerAnimating = true;
            $('.c-banner-paralax').addClass('is--animating');
            if (state == 'up') {
                paraBannerUp();
            } else if (state == 'down') {
                paraBannerDown();
            }
            setTimeout(function () {
                paraBannerAnimating = false;
                $('.c-banner-paralax').removeClass('is--animating');
            }, paraBannerAnimationSpeed);
        }
    }
    // if($('html')[0].scrollTop == 0) {
    //     paraBannerStart();
    // }
}

function paraBannerDown() {
    paraBannerSlideIndex = $('.js-video-nav.is--active').index() + 1;
    if (paraBannerSlideIndex >= paraBannerTotalSlides - 1) {
        paraBannerSlideIndex = paraBannerTotalSlides - 1;
        // paraBannerFinished();
        paraBannerMove();
        setTimeout(function () {
            paraBannerFinished();
        }, 100);
    } else {
        paraBannerMove();
    }
}

function paraBannerUp() {
    paraBannerSlideIndex = $('.js-video-nav.is--active').index() - 1;
    if (paraBannerSlideIndex < 0) {
        paraBannerSlideIndex = 0;
    }
    paraBannerMove();
}

function paraBannerMove() {
    for (x = 0; x < paraBannerTotalSlides; x++) {
        paraBanner.removeClass('sec-on--' + x);
    }
    paraBanner.addClass('sec-on--' + paraBannerSlideIndex);

    // Movie Video To
    paraBanner.find('.video-nav a').eq(paraBannerSlideIndex).click();
}

function paraBannerFinished() {
    $('html').removeClass('banner-paralax--scroll');
    paraBannerActive = false;
}

function paraBannerStart() {
    if (winWidth <= 1024) {
        $('html').addClass('banner-paralax--scroll');
    }
    paraBannerActive = true;
}

/* END - Banner Paralax */
/* ============================== */


//Aga

function headerFixed() {
    var scroll = $(window).scrollTop();
    if ($('.js-page-scroll').get(0)) {
        if (scroll < ($('.js-page-scroll').height() - winHeight)) {
            $('body').removeClass("header-fixed");
        } else {
            if($('.c-video-banner-scroll').get(0) && scroll <= 1){
                return;
            }
            $('body').addClass("header-fixed");
        }
    } else {
        if (scroll < 50) {
            $('body').removeClass("header-fixed");
        } else {
            $('body').addClass("header-fixed");
        }
    }
}

function calApplyHeights() {
    headerHeight = $('.header-cover').outerHeight();
    $('.c-header').css({
        'height': headerHeight
    });
}

function jsScrollDown() {
    $('.js-scroll-down').click(function (e) {
        e.preventDefault();
        $('html').removeClass('banner-paralax--scroll');
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $('.c-video-banner-wrap').height() - headerHeight + 10
            }, 1200);
        }, 100);
    });
};
$('.js-hamburger').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-cross');
    $('.c-header').toggleClass('nav-open');
    $('.mobile-nav-box').fadeToggle();
    $('body').toggleClass('modal-open')
})

/* ============================== */
/* START - SVG MAP */

var svgPan = [];

function zoomSVG() {
    var eventsHandler;
    eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: function (options) {
            var instance = options.instance,
                initialScale = 1,
                pannedX = 0,
                pannedY = 0;

            // Init Hammer
            // Listen only for pointer and touch events
            this.hammer = Hammer(options.svgElement, {
                inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
            })

            // Enable pinch
            this.hammer.get('pinch').set({
                enable: true
            })

            // Handle double tap
            this.hammer.on('doubletap', function (ev) {
                instance.zoomIn()
            })

            // Handle pan
            this.hammer.on('panstart panmove', function (ev) {
                // On pan start reset panned variables
                if (ev.type === 'panstart') {
                    pannedX = 0
                    pannedY = 0
                }

                // Pan only the difference
                instance.panBy({
                    x: ev.deltaX - pannedX,
                    y: ev.deltaY - pannedY
                })
                pannedX = ev.deltaX
                pannedY = ev.deltaY
            });

            // Handle pinch
            this.hammer.on('pinchstart pinchmove', function (ev) {
                // On pinch start remember initial zoom
                if (ev.type === 'pinchstart') {
                    initialScale = instance.getZoom()
                    instance.zoom(initialScale * ev.scale)
                }

                instance.zoom(initialScale * ev.scale)
            });

            // Prevent moving the page on some devices when panning over SVG
            options.svgElement.addEventListener('touchmove', function (e) {
                e.preventDefault();
            });
        },
        destroy: function () {
            this.hammer.destroy();
        }
    }

    var beforePan, customPan, mylatesttap, hideMsgTimeout = [];

    $('.block-zoom-mobile-msg').each(function (i) {
        $(this).attr('data-svg-id', i);
        this.addEventListener("touchmove", function () {
            $(this).css('opacity', 1);
            var that = this;
            var thisId = $(this).attr('data-svg-id');
            if (hideMsgTimeout[thisId]) {
                clearTimeout(hideMsgTimeout[thisId]);
            }
            hideMsgTimeout[thisId] = setTimeout(function () {
                $(that).css('opacity', 0)
            }, 2000);
        }, false);
    });

    $(window).scroll(function () {
        $('.block-zoom-mobile-msg').attr('style', function (i, style) {
            return style && style.replace(/display[^;]+;?/g, '');
        });
    });

    $('.block-zoom-mobile-msg').on('click', function (e) {
        e.preventDefault();
        $(this).css('opacity', 1);
        var that = this;
        var thisId = $(this).attr('data-svg-id');
        if (hideMsgTimeout[thisId]) {
            clearTimeout(hideMsgTimeout[thisId]);
        }
        hideMsgTimeout[thisId] = setTimeout(function () {
            $(that).css('opacity', 0);
        }, 2000);
        if (winWidth > 1024 || doubletap()) {
            $(that).css('display', 'none');
        }
    });

    function doubletap() {
        var now = new Date().getTime();
        var timesince = now - mylatesttap;
        if ((timesince < 600) && (timesince > 0)) {
            mylatesttap = new Date().getTime();
            return true;
        }
        mylatesttap = new Date().getTime();
        return false;
    }
    adjustLayoutFloorPlanMobile();

    $(".js-zoom-pan").each(function (i) {
        beforePan = function (oldPan, newPan) {
            var stopHorizontal = false,
                stopVertical = false,
                gutterWidth = 100,
                gutterHeight = 100
                // Computed variables
                ,
                sizes = this.getSizes(),
                leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth,
                rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom),
                topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
                bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)

            customPan = {}
            customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
            customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))

            return customPan
        }
        svgPan[i] = svgPanZoom(this, {
            zoomEnabled: true,
            controlIconsEnabled: false,
            // fit: 1,
            contain: true,
            fit: false,
            center: 1,
            beforePan: beforePan,
            customEventsHandler: eventsHandler
        });
        $(this).siblings('.svg-control').attr('data-svg-index', i);
    });

    $(".js-svg-control a").click(function () {
        var svgPanIndex = $(this).parent().data('svg-index');
        if ($(this).hasClass('zoomOut')) {
            svgPan[svgPanIndex].zoomOut();
        }
        if ($(this).hasClass('zoomIn')) {
            svgPan[svgPanIndex].zoomIn();
        }
    })
}

var beforePan, customPan, mylatesttap, hideMsgTimeout = [];

$('.block-zoom-mobile-msg').each(function (i) {
    $(this).attr('data-svg-id', i);
    this.addEventListener("touchmove", function () {
        $(this).css('opacity', 1);
        var that = this;
        var thisId = $(this).attr('data-svg-id');
        if (hideMsgTimeout[thisId]) {
            clearTimeout(hideMsgTimeout[thisId]);
        }
        hideMsgTimeout[thisId] = setTimeout(function () {
            $(that).css('opacity', 0)
        }, 2000);
    }, false);
});

function loadDelayedSvgs() {
    $('.js-svg-viewer').addClass('is--loading');
    $('[data-svgSrc]').each(function () {
        var thisImgSrc = $(this).attr('data-svgSrc');
        $(this).after('<img src="' + thisImgSrc + '" alt="">');
        $('+ img', this).addClass('changeToSvg js-zoom-pan');

        $('+ img', this)[0].addEventListener('load', loadZoomIfSVGReady)
        $('+ img', this)[0].addEventListener('error', function () {
            console.error('svg floor image failed to load!');
        });

        $(this).remove();
    });
}

function loadZoomIfSVGReady() {
    var allLoaded = true;
    $('img.js-zoom-pan').each(function () {
        if (!this.complete) {
            allLoaded = false;
        }
    });
    if (allLoaded) {
        $('.js-svg-viewer svg, .js-svg-viewer img').css('opacity', 0);
        ChangeToSvg();
    }
}

function loadZoomPluginFunctionality() {
    zoomSVG();
}

function ChangeToSvg() {
    var imgsConvertTotal = $('img.changeToSvg').length;
    var imgsConvertedCount = 0;
    jQuery('img.changeToSvg').each(function () {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function (data) {
            var $svg = jQuery(data).find('svg');
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, else we gonna set it if we can.
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

            imgsConvertedCount++;

            if (imgsConvertedCount == imgsConvertTotal) {
                loadZoomPluginFunctionality();
            }

        }, 'xml');

        $('.js-svg-viewer svg, .js-svg-viewer img').css('opacity', 1);
        $('.js-svg-viewer').removeClass('is--loading');
    });
}

function adjustLayoutFloorPlanMobile() {
    if (winWidth < 768) {
        $(".floorplan_sec.is--mobile .floor-info-wrap").each(function () {
            $('.on--floor', this).after($(this).parent().next());
        });
    }
}

/* END - SVG MAP */
/* ============================== */


/* ============================== */
/* START - Tabs */

function initTabs() {
    $('.js-tab-link').click(function (e) {
        e.preventDefault();
        tabOpen(this);
    });

    // Open First Tab
    var tabNames = [];
    $('.js-tab-link').each(function () {
        var thisTabName = $(this).attr('data-tab-name');
        tabNames.indexOf(thisTabName) === -1 && tabNames.push(thisTabName);
    });
    for (var i = 0; i < tabNames.length; i++) {
        $(`.js-tab-link[data-tab-name="${tabNames[i]}"]`).eq(0).trigger('click');
    }
}

function tabOpen(link) {
    var tabName = $(link).attr('data-tab-name');
    var target = $(link).attr('href');
    var tabLinks = $(`.js-tab-link[data-tab-name="${tabName}"]`);
    var tabContent = $(`.js-tab-content[data-tab-name="${tabName}"]`);

    tabLinks.removeClass('is--active');
    tabContent.removeClass('is--active');

    tabContent.css('height', '0');

    $(link).addClass('is--active');
    $(target).addClass('is--active');

    $(target).css('height', '');
}


/* END - Tabs */
/* ============================== */

function initSideNav() {
    var navWidth = 0;
    var targetedNavID = [];
    if((browserName == 'Safari' && browserVersion < 13) || browserName == 'Edge') {
        $('html').addClass('no--sticky-content');
    }else{
        $('.js-side-nav .c-ver-nav .nav > *').each(function () {
            navWidth += $(this).width() + 10;
            var id = $(this).find('a').attr('href');
            targetedNavID.push(id);
        });
        navWidth += parseInt($('.js-side-nav .c-ver-nav .nav').css('padding-left'));
        $('.js-side-nav .c-ver-nav, .ver-nav-wrap').css('height', navWidth + 'px');
        $('.js-side-nav').theiaStickySidebar({
            'containerSelector': '.js-side-nav-wrap',
            'updateSidebarHeight': false,
        });
    
        setCalcs();
        $('.js-side-nav-content').theiaStickySidebar({
            'containerSelector': '.js-side-nav-wrap',
            'updateSidebarHeight': false,
        });
        
        $(window).on('scroll', function () {
            for (var i = 0; i < targetedNavID.length; i++) {
                if (isInViewport($(targetedNavID[i])[0], true)) {
                    $('.js-side-nav .c-ver-nav .nav li').removeClass('active');
                    $('.js-side-nav .c-ver-nav .nav li a[href="' + targetedNavID[i] + '"]').parent().addClass('active');
                    if(winWidth > 1199) {
                        $('.js-side-nav-content .section-heading').removeClass('is--active');
                        $('.js-side-nav-content .section-heading').eq(i).addClass('is--active');
                    }
                }
            }
        });
    
        $('.js-to-href').click(function (e) {
            e.preventDefault();
            var targetId = $(this).attr('href');
            var targetScrollPos = $(targetId).offset().top;
            $('html, body').animate({
                scrollTop: targetScrollPos - headerHeight + 10
            }, 500);
        });
    
    
        $(window).on('resize orientationchange', function(){
            if(resized) {
                setCalcs();
            }
        });
        
    }

    function setCalcs() {
        if(winWidth <= 1199) {
            $('.js-side-nav-content').css('height', '');
            $('.js-side-nav-wrap .c-content-section-1').css('padding-top', '');
        }else{
            $('.js-side-nav-content').attr('style', '');
            setPadding();
            setTimeout(function(){
                setPadding();
            }, 100);
        }
    }
    function setPadding() {
        var navContentHeight = $('.js-side-nav-content .theiaStickySidebar').height();
        $('.js-side-nav-content').css('height', navContentHeight);
        $('.js-side-nav-wrap .c-content-section-1').css('padding-top', navContentHeight);
    }
}

function initDataDesktopMob() {
    if (winWidth >= 768) {
        $('[data-desktop-poster]').each(function () {
            var thisSrc = $(this).attr('data-desktop-poster');
            $(this).attr('poster', thisSrc);
        });
        $('[data-desktop-src]').each(function () {
            var thisSrc = $(this).attr('data-desktop-src');
            $(this).attr('src', thisSrc);
            if(this.tagName == 'VIDEO') {
                pushActiveVideo($(this));
                $(this).parent().find('video')[0].load();
            }
        });
        $('[data-desktop-video]').each(function () {
            var thisSrc = $(this).attr('data-desktop-video');
            $(this).html(`        
                <video playsinline preload="auto" muted>
                    <source src="${thisSrc}" type="video/mp4" />
                </video>
            `);
            $(this).find('video')[0].load();
        });
        $('[data-desktop-style]').each(function(){
            $(this).attr('style', $(this).attr('data-desktop-style'));
        });
    } else {
        $('[data-mob-poster]').each(function () {
            var thisSrc = $(this).attr('data-mob-poster');
            $(this).attr('poster', thisSrc);
        });
        $('[data-mob-src]').each(function () {
            var thisSrc = $(this).attr('data-mob-src');
            $(this).attr('src', thisSrc);
            pushActiveVideo($(this));
            $(this).parent().find('video')[0].load();
        });
        $('[data-mob-video]').each(function () {
            var thisSrc = $(this).attr('data-mob-video');
            $(this).html(`
                <video playsinline preload="auto" muted>
                    <source src="${thisSrc}" type="video/mp4" />
                </video>
            `);
        });
        $('[data-mob-style]').each(function(){
            $(this).attr('style', $(this).attr('data-mob-style'));
        });
    }
    function pushActiveVideo(target){
        var targetVideo = target.parent();
        if(targetVideo.is('video')) {
            var videoHTML = targetVideo[0].outerHTML;
            targetVideo.parent().html(videoHTML);
        }
    }
}

function initWOW() {
    if($('html').hasClass('no--sticky-content')) {
        $('.c-draggable .txt-area, .c-content-section-1 > .c-img-box-tabs').addClass('wow fadeInUp');
    }else{
        $('.c-draggable .txt-area, .c-content-section-1 > .c-img-box-tabs').addClass('wow fadeInUp');
    }
    new WOW().init();
    if($('.c-draggable').get(0)){
        $(window).on('scroll', function () {
            $('.c-draggable').each(function(){
                if(isInViewport($(this)[0], true)){
                    $(this).addClass('in--view');
                }
            });
        });
    }
}

function initCarousel() {
    $('.js-carousel').each(function () {
        var thisCarousel = $(this).slick({
            arrows: false,
            rtl: isRTL,
        });

        var carouselWrap = thisCarousel.closest('.js-carousel-wrap');
        var carouselNav = carouselWrap.find('.js-carousel-nav');
        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            updateCarouselNav(nextSlide, carouselNav);
        });
        updateCarouselNav(0, carouselNav);

        carouselNav.find('a').click(function (e) {
            e.preventDefault();
            thisCarousel.slick('slickGoTo', $(this).parent().index());
        });
    });
}

function updateCarouselNav(slideIndex, carouselNav) {
    carouselNav.find('li').removeClass('is--active');
    carouselNav.find('li').eq(slideIndex).addClass('is--active');
}


var iV_played = false,
    iV_played_interval;

function initInteractiveView() {
    if ($('.js-interactive-view').get(0)) {
        // Play Video On Arrival
        // $(window).on('scroll', function () {
        //     if (iV_played == false) {
        //         if (isInViewport($('.js-interactive-view')[0])) {
        //             $('.js-interactive-view .js-video-nav').eq(0).trigger('click');
        //             var interval = parseInt($('.js-interactive-view .js-video-nav').eq(0).attr('data-video-target'));
        //             iV_played = true;
        //             setTimeout(function () {
        //                 $('.js-interactive-view').addClass('activate');
        //             }, interval * 1000);
        //         }
        //     }
        // });

        // Setup Initial Point View Logic
        $('.js-view-point').click(function (e) {
            e.preventDefault();
            $(this).closest('.view-points').find('.point').removeClass('is--active');
            $(this).closest('.point').addClass('is--active');
            if (winWidth < 768) {
                var dataPointID = $(this).attr('data-point');
                $(this).closest('.view-points').find('[data-point-content]').removeClass('is--active');
                $('[data-point-content="' + dataPointID + '"]').addClass('is--active');
            }
        });
        $('.js-close-point').click(function (e) {
            e.preventDefault();
            $(this).closest('.point').removeClass('is--active');
            if (winWidth < 768) {
                $(this).closest('.point-content').removeClass('is--active');
            }
        });
        $('.js-interactive-view .point').each(function (i) {
            var thisTop = parseInt(this.style.top);
            var thisLeft = parseInt(this.style.left);
            if (thisTop > 50) {
                $(this).addClass('align-bot');
            }
            if (thisLeft > 50) {
                $(this).addClass('align-right');
            }
            if (winWidth < 768) {
                $('a', this).attr('data-point', i);
                $('.point-content', this).attr('data-point-content', i);
                $('.point-content', this).appendTo($(this).closest('.view-points'));
            }
        });

        // Toggle Handler
        var isSwiped = false,
            isSwipedTimeout;
        $(".js-toggle-btn")
            .swipeDetector()
            .on("swipeLeft.sd swipeRight.sd clicked.sd", function (event) {
                event.preventDefault();
                isSwiped = true;
                clearTimeout(isSwipedTimeout);
                isSwipedTimeout = setTimeout(function () {
                    isSwiped = false;
                }, 10);
                if (event.type === "swipeLeft") {
                    $(this).removeClass('toggle-on');
                } else if (event.type === "swipeRight") {
                    $(this).addClass('toggle-on');
                } else if (event.type === "clicked") {
                    $(this).toggleClass('toggle-on');
                }
                toggleViewPoints();
            });
        toggleViewPoints(true);
    }
}
function toggleViewPoints(firstRun) {
    $('.js-interactive-view .view-points-wrap .view-points').removeClass('is--active');
    var targetId = 0;
    if ($('.js-toggle-btn').hasClass('toggle-on')) {
        targetId = 1;
        subtractWaitTime = $('.js-interactive-view .hidden-links a').eq(0).attr('data-video-target');
    }
    if (!firstRun) {
        $('.js-interactive-view .hidden-links a').eq(targetId).trigger('click');
    }
}

function interactiveVideoReachedDestination() {
    var targetId = 0;
    if ($('.js-toggle-btn').hasClass('toggle-on')) {
        targetId = 1;
    }
    $('.js-interactive-view .view-points-wrap .view-points').eq(targetId).addClass('is--active');
}

var isInViewport = function (el, firstGlimps) {
    var topa = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        topa += el.offsetTop;
        left += el.offsetLeft;
    }
    
    // if (firstGlimps) {
    //     topa -= -height * 0.2;
    // } else {
    //     topa -= -height * 0.9;
    // }

    return (
        topa < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (topa + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
};

/* ============================== */
/* START - Draggable */

function initDraggable() {
    $('.js-drag').each(function () {
        var thisTop = $(this).css('top');
        var thisLeft = $(this).css('left');
        $(this).attr('data-init-top', thisTop);
        $(this).attr('data-init-left', thisLeft);
    });
    $('.js-draggable-container').each(function () {
        $('.js-drag', this).draggable({
            containment: $(this),
            scroll: false
        });
    });

    $('.js-reset-drag').click(function (e) {
        e.preventDefault();
        $(this).closest('.js-draggable-container').find('.js-drag').each(function () {
            var initTop = $(this).attr('data-init-top');
            var initLeft = $(this).attr('data-init-left');
            $(this).css({
                'top': initTop,
                'left': initLeft
            });
        });
    });
    $('.js-reset-drag').trigger('click');
    $(window).on('resize orientationchange', function () {
        if(resized) {
            $('.js-drag').each(function () {
                $(this).css('top', '');
                $(this).css('left', '');
                var thisTop = $(this).css('top');
                var thisLeft = $(this).css('left');
                $(this).attr('data-init-top', thisTop);
                $(this).attr('data-init-left', thisLeft);
                $('.js-reset-drag').trigger('click');
            });
        }
    });
}

/* END - Draggable */
/* ============================== */


/* ============================== */
/* START - Paralax */

var paralaxOffset = 250;
if(winWidth < 768){
	paralaxOffset = 100;
}
$('.js-paralax1 > *').css({transform: 'translateY('+paralaxOffset+'px) translateZ(0)'});

function paralax1() {
	var paralaxOffset = 250;
	if(winWidth < 768){
		paralaxOffset = 100;
	}
	$('.js-paralax1').each(function () {
		var thisHeight = this.getBoundingClientRect().height;
        var thisTopView = this.getBoundingClientRect().top;
		var thisBotView = thisTopView + thisHeight;

		// In View
        var percentComplete = thisBotView/(winHeight+thisHeight)*100;
        if($(this).hasClass('js-paralax1--reverse')) {
            percentComplete = 100 - percentComplete;
        }
        var percntRatio = -(paralaxOffset/100*percentComplete);

        percntRatio = paralaxOffset-(paralaxOffset/50*(Math.abs(percentComplete-100)));
        if(percntRatio <= 0){  percntRatio = 0; }
        $(this).css({transform: 'translateY('+percntRatio+'px) translateZ(0)'});
	});
	
}
/* END - Paralax */
/* ============================== */

/* ============================== */
/* START - Jquery Validation */
jQuery.validator.addMethod("phonenu", function (value, element) {
    if (/([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/g.test(value)) {
        return true;
    } else {
        return false;
    };
}, "Invalid phone number");

jQuery.validator.addMethod("alphanumeric", function(value, element) {
    return this.optional(element) || /^\w+$/i.test(value);
}, "Letters, numbers, and underscores only please");

jQuery.validator.addMethod("noHTMLtags", function(value, element){
    if(/<\/?[^>]+(>|$)/g.test(value)){
        return false;
    } else {
        return true;
    }
}, "HTML tags are Not allowed.");

function validation(target) {
    if ($(target).length) {
        var $target = $(target);
        $target.each(function (i, e) {
            vform = $target.eq(i).validate({
                errorElement: 'span',
                errorClass: 'invalid-field',
                onfocusout: function (element) {
                    this.element(element);
                },
                highlight: function (element) {
                    $(element).parents('.form-group').addClass('invalid-field');
                    $(element).parents(target).find(".is--note").addClass('error-msg');
                    checkvalidation('.js-form-validation',$(element));
                },
                unhighlight: function (element) {
                    $(element).parents('.form-group').removeClass('invalid-field');
                    checkvalidation('.js-form-validation',$(element));
                },
                errorPlacement: function (error, element) {},
                invalidHandler: function (form, validator, element) {
                    var errors = validator.numberOfInvalids();
                    if (errors) {
                        $target.eq(i).find(".is--note").addClass('error-msg');
                        $(element).parents('.form-group').addClass('invalid-field');
                    } else {
                        $target.eq(i).find(".is--note").removeClass('error-msg');
                        $(element).parents('.form-group').removeClass('invalid-field');
                    }
                    checkvalidation('.js-form-validation',$(element));
                },
                submitHandler: function (form) {
                    if (form_status == 0) {
                        form_status = 1;
                        grecaptcha.execute();
                        mainform(form);
                    }
                }
            });
        });
        $('.js-phonenu').each(function () {
            var $ths = $(this);
            phonenu = $ths.attr('name');
            $(this).rules('add', {
                phonenu: true,
            });
        });
        $('.js-number').each(function () {
            $(this).rules('add', {
                number: true,
            });
        });
        $('.js-alphanumeric').each(function () {
            $(this).rules('add', {
                alphanumeric: true,
            });
        });
        $('.form-control').each(function () {
            $(this).rules('add', {
                noHTMLtags: true,
            });
        });
    }
}

function checkvalidation(target,clk){
    if ($(target).validate().checkForm()) {
        clk.parents(target).find('.btn').prop('disabled', false);
        $('.is--note').removeClass('error-msg');
    } else {
        clk.parents(target).find('.btn').prop('disabled', 'disabled');
        $('.is--note').addClass('error-msg');
    }
}

/* END - Jquery Validation */
/* ============================== */

function langPopup() {
    if($('.is--home').get(0)) {
        openPopup('#language-selector');
    }
}

function openPopup(target) {
    var popnam = target;
    popCls = popnam.substring(1, popnam.length);
    $('body').addClass(popCls);
    $('html').addClass('popup-is-active');
    $(target).show();
    $(target).closest('.c-popup').show();
    setTimeout(function () {
        $(target).addClass('active');
        $(target).closest('.c-popup').addClass('popup--open');
        if ($(target).find('.plyr').length) {
            var videoInstance = $(target).find('.plyr').attr('data-video-instance');
            players[videoInstance].play();
        }
    }, 10);
}

function closePopup() {
    $('body').removeClass(popCls);
    if ($('.c-popup .active').length) {
        // Close Popup
        //===========

        // Play video ater close if is first load popup
        if($('#first-load.active').get(0) && $('.js-page-scroll.js-page-scroll-a').get(0)) {
            setTimeout(function () {
                isStartingAutoPlay = true;
                pageScrollVideoPlayNow();
            });
        }

        $('.c-popup .active').removeClass('active');
        $('.c-popup').removeClass('popup--open');
        setTimeout(function () {
            $('.c-popup .popup').hide();
            $('.c-popup').hide();
            $('html').removeClass('popup-is-active');
        }, 310);
    }
}

function bindPopupEve() {
    // Popup Open
    $('.js-popup-link').click(function (e) {
        e.preventDefault();
        if ($(this).data('popup')) {
            var target = $(this).data('popup');
        } else {
            var target = $(this).attr('href');
        }
        openPopup(target);
        ChangeToSvg();
    });
    // Popup Close
    $('.js-close-popup').click(function (e) {
        e.preventDefault();
        closePopup();
    });
}

function fieldsfilter() {
    $(".js-fieldsfilterbtn").on('change', function () {
        if ($(this).val() == "yes") {
            $(".yesFields").fadeIn();
            $(".noFields").fadeOut();
        } else {
            $(".noFields").fadeIn();
            $(".yesFields").fadeOut();
        }
        // vform.destroy();
        setTimeout(function(){
            // vform.resetForm();
            checkvalidation('.js-form-validation',$('.js-input-check[required]'));
        },500);
    });
}


/* ============================== */
/* START - Cookie */
function initCookie() {
    var app_launch = getCookie('app_launch');
    if (!app_launch) {
        // initPopup = true;
        // openPopup('#first-load');
    }
    setCookie('app_launch', 1);
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/* END - Cookie */
/* ============================== */


/* ============================== */
/* START - Calendar */

var startDate = new Date("6-7-2020");

function returnStartDate() {
    var currentDate = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(new Date().getDate()+1);
    var dayAfterTomorrow = new Date();
    dayAfterTomorrow.setDate(new Date().getDate()+2);
    var currentHourKSA = currentDate.getUTCHours() + 3;
    var currentMinuteKSA = (currentDate.getMinutes() / 60);
    var currentTime = currentHourKSA + currentMinuteKSA;
    // var currentSelectedDate = $('.js-flatpickrinline')[0]._flatpickr.selectedDates[0];
    // var isCurrentDate = (currentDate.toDateString() == currentSelectedDate.toDateString());

    if (currentTime >= 16) {
        return new Date(dayAfterTomorrow.toDateString());
    } else {
        return new Date(tomorrow.toDateString());
    }
}

function checkTiming() {
    var currentDate = new Date();
    var currentHourKSA = currentDate.getUTCHours() + 3;
    var currentMinuteKSA = (currentDate.getMinutes() / 60);
    var currentTime = currentHourKSA + currentMinuteKSA;
    var currentSelectedDate = $('.js-flatpickrinline')[0]._flatpickr.selectedDates[0];
    var isCurrentDate = (currentDate.toDateString() == currentSelectedDate.toDateString());

    if (isCurrentDate && currentTime >= 10.5) {
        $($('.js-select-time').get(0)).addClass('is--booked')
        $($('.js-select-time').get(1)).addClass('is--booked')
    } else if (isCurrentDate && currentTime >= 8 ) {
        $($('.js-select-time').get(0)).addClass('is--booked')
    }
}

function initDatepicker(target, vInline, smonth){
    var $target = $(target);
    if(smonth == 2){
        if(winWidth < 1200) {
            smonth = 1
        }
    }
    if(vInline == 'true'){
        if(winWidth < 992) {
            vInline = false
        }
    }
    $target.each(function (i, e) {
        var tarPar = $(e).parents('.datepicker-box');
        $(e).flatpickr({
            dateFormat: "j M Y, l",
            minDate: returnStartDate(),
            disableMobile: "true",
            inline: vInline,
            showMonths: smonth,
            "disable": [
                function(date) {
                    // return true to disable
                    return (date.getDay() === 5 || date.getDay() === 6);
                }
            ],
            "locale": {
                "firstDayOfWeek": 0 // start week on Monday
            },
            locale: $('html').attr('lang'),
            shorthandCurrentMonth: false,
            disable: [
                function(date) {
                    // return true to disable
                    return (date.getDay() === 5 || date.getDay() === 6);
                }
            ],
            onReady: function(selectedDateCore, selectedDate, element) {
				$(element.weekdayContainer).find('.flatpickr-weekday').each(function(i, el) {
					el.innerText = el.innerText.replace('Sun', 'S');
					el.innerText = el.innerText.replace('Mon', 'M');
					el.innerText = el.innerText.replace('Tue', 'T');
					el.innerText = el.innerText.replace('Wed', 'W');
					el.innerText = el.innerText.replace('Thu', 'T');
					el.innerText = el.innerText.replace('Fri', 'F');
					el.innerText = el.innerText.replace('Sat', 'S');
                });
                var firstActiveDate = new Date(returnStartDate());
                if (firstActiveDate.getDay() == 5) {
                    firstActiveDate.setDate(firstActiveDate.getDate()+2);
                } else if(firstActiveDate.getDay() == 6) {
                    firstActiveDate.setDate(firstActiveDate.getDate()+1);
                }
                element.setDate(firstActiveDate, 'onChange');
            },
            onChange: function(selectedDates, dateStr, instance) {
                UpdateTimeSlot(dateStr, instance);
            }
        });
    });
}
/* END - Calendar */
/* ============================== */

function GetJSONData(dataFile, actionMethod) {
    return $.ajax({
        method: actionMethod,
        url: dataFile,
        contentType: 'application/json',
        crossDomain: true,
        async: false,
        success: function (data) {
            return data;
        },
        error: function (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
    });
}

function UpdateTimeSlot(selectedDate, target) {
    $('.js-time-slot-box').addClass('is--fetching');
    $('.js-selected-date').html(selectedDate);
    $('.js-selected-input-date').val(target.selectedDates[0].toDateString());
    $('.js-next-step').attr('disabled', true);
    var parentTarget = $(target._input).parents('.datepicker-box'),
        dataURL = parentTarget.data('url'),
        dataMethod = parentTarget.data('method'),
        dateFormat = target.latestSelectedDateObj.toISOString();
        data = GetJSONData(dataURL+'?dt='+dateFormat, dataMethod).responseJSON.timeslot.timeslots,
        timeSlotHTML = '';

    for (var index = 0; index < data.length; index++) {
        var indexedData = data[index];
        var indexTime = indexedData.time;
        var indexAvailable = (data[index].availability) ? 'is--available' : 'is--booked';
        timeSlotHTML += '<li><a href="javascript:;" class="js-select-time '+ indexAvailable +'">'+ indexTime +'</a></li>';
    }

    $('.js-time-slots').html(timeSlotHTML);
    $('.js-time-slot-box').removeClass('is--fetching');

    selectTimeSlot();
}

function selectTimeSlot() {
    $('.js-select-time').on('click', function () {
        $('.js-select-time').removeClass('is--selected');
        $(this).addClass('is--selected');
        $('.js-selected-time').html($(this).text());
        $('.js-selected-input-time').val($(this).text());        
        $('.js-next-step').removeAttr('disabled')
    })
}

$('.js-next-step').on('click', function (e) {
    var $this = $(e.currentTarget);
    var stepParent = $this.parents('.step');
    var nextStep = stepParent.next();
    stepParent.removeClass('is--active');
    nextStep.addClass('is--active');
})


$('.js-to-home-top').click(function(e){
    e.preventDefault();
    $('.js-scroll-video-nav:nth-child(6)').trigger('click');
});
$('p, h1, h2, h3, h4, h5, h6').widont();